<template>
	<!-- 这边是中国的数据来源 暂不做国际化 -->
	<div class="sourceAnalysis">
		<div class="dataScreening">
			<div style="display: flex; justify-content: space-between">
				<span>数据总览</span>
				<!-- <span>更新于 : {{ screening.updateTime }}</span> -->
			</div>

			<div class="data_box">
				<div class="data_show">
					<span>今日新增数据</span>
					<span style="margin-top: 35px; font-size: 28px; color: #ff4200">{{ screening.todayNewDate }}</span>
				</div>
				<div class="data_show">
					<span>总数据量</span>
					<span style="margin-top: 35px; font-size: 28px; color: #0080ff">{{ screening.allData }}</span>
				</div>
				<div class="data_show_right">
					<span>平均答题时长</span>
					<span style="margin-top: 35px; font-size: 28px; color: #33a83b">{{ screening.averageAnswerTime }}</span>
				</div>
			</div>
		</div>
		<!-- 来源分析 -->
		<!-- 地域分布 -->
		<div class="geographical_distribution">
			<p style="font-size:16px;color:#333;padding-top:34px;margin-bottom:16px">地域分布</p>
			<div class="geographical_distribution_div">
				<div class="map"><div id="myChartChina" :style="{ height: '450px' }" style="padding-top:30px"></div></div>
				<div class="mapStatistics"><div id="main" style="width: 400px;height:400px;"></div></div>
			</div>
			<!-- <el-empty v-else>
				<el-button type="primary">按钮</el-button>
			</el-empty> -->
		</div>

		<!-- 访问环境 -->
		<div class="access_environment">
			<span style="font-size:16px;color:#333">访问环境</span>
			<div class="chart_box">
				<div style="padding-top:20px;margin-left:20px">
					<el-select v-model="type" placeholder="请选择" @change="changeType">
						<el-option v-for="item in accessEnvironment" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div style="width:100%;height:500px;background:#fff"><div id="barChart" style="width:900px;height:400px;margin:0 auto;margin-top:50px"></div></div>
			</div>
			<!-- <el-empty v-else></el-empty> -->
		</div>
		
		<el-dialog title="修改提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
			<div style="padding: 15px; text-indent: 2em"><span>您确认修改此问卷吗？该问卷所有数据收集将被停止，答卷链接暂时关闭！</span></div>
		
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="handleConfirmClick">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import echarts from 'echarts';
// require('echarts/theme/macarons');
import china from 'echarts/map/json/china.json';
echarts.registerMap('china', china);
export default {
	data() {
		return {
			next: null,
			dialogVisible:false,
			screening: {},
			TopEmpty: false,
			BotEmpty: false,
			type: 0,
			cityData: [],
			regionData: [],
			accessEnvironment: [
				{
					label: '按设备类型',
					value: 0
				},
				{
					label: '按浏览器',
					value: 1
				},
				{
					label: '按操作系统',
					value: 2
				}
			],
			value: '',
			chaertData: [],
			mapData: [],
			ringData: [],
			optionring: {},
			barOption: {},
			mapEchart: null
		};
	},
	beforeRouteLeave(to, from, next) {
		// 导航离开该组件的对应路由时调用
		// 可以访问组件实例 `this`
		if (to.name != 'QuestionType') {
			next();
		} else {
			let state = sessionStorage.getItem('wstate');
			if (state && state != 1) {
				this.next = next;
				this.dialogVisible = true;
			} else {
				next();
			}
		}
	},
	mounted() {
		this.wid = sessionStorage.getItem('wid');
		this.chartData();
		this.loadData();
		this.queryTotaldata();
	},
	methods: {
		handleClose() {
			this.dialogVisible = false;
		},
		handleConfirmClick() {
			this.dialogVisible = false;
			this.wid = sessionStorage.getItem('wid') || 0;
			this.$api.UpdateQuestionnaireState({
				id: this.wid,
				state: 1
			});
			this.next();
		},
		queryTotaldata() {
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				// ${that.$config.service.questiondel}?id=${id}
				url: `${this.$config.service.querydataSurvey}?questionnaireId=${id}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.screening = res.resultBody;
						that.pageTotal = Number(res.resultBody.allData);
					}
				}
			};
			this.$util.request(params);
		},
		// 柱状图
		barChart(datax, datay) {
			var myChart = echarts.init(document.getElementById('barChart'));
			this.baroption = {
				xAxis: {
					type: 'category',
					data: datax
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						data: datay,
						type: 'bar',
						showBackground: true,
						barWidth: 50,
						backgroundStyle: {
							color: 'rgba(220, 220, 220, 0.8)'
						},
						itemStyle: {
							normal: {
								//这里是重点
								color: function(params) {
									//注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
									var colorList = ['#18aeb7', '#1f6588', '#55acff', '#8ce0ff'];
									return colorList[params.dataIndex];
								}
							}
						}
					}
				]
			};
			myChart.setOption(this.baroption);
			window.onresize = function() {
				myChart.resize();
			};
		},
		// 地图初始化
		initChart(data) {
			// 基于准备好的dom，初始化echarts实例
			var myChartContainer = document.getElementById('myChartChina');
			var resizeMyChartContainer = function() {
				myChartContainer.style.width = document.body.offsetWidth / 2.8 + 'px'; //页面一半的大小
			};
			resizeMyChartContainer();
			var myChartChina = this.$echarts.init(myChartContainer);
			this.mapEchart = myChartChina;
			function randomData() {
				return Math.round(Math.random() * 500);
			}
			// 绘制图表
			var optionMap = {
				tooltip: {
					// 鼠标移到图里面的浮动提示框
					// formatter详细配置： https://echarts.baidu.com/option.html#tooltip.formatter
					formatter(params, ticket, callback) {
						// console.log({ params: params, ticket: ticket, callback: callback });
						// params.data 就是series配置项中的data数据遍历
						let crew, num;
						if (params.data) {
							crew = params.data.name || '';
							num = params.data.value || 0;
						} else {
							// 为了防止没有定义数据的时候报错写的
							crew = params.name || '';
							num = 0 || 0;
						}
						let htmlStr = `
                        <p style='text-align:left;margin-top:0px;'>
                            ${crew}：${num}<br/>
                        </p>
                        `;
						return htmlStr;
					}
				},
				// visualMap的详细配置解析：https://echarts.baidu.com/option.html#visualMap
				visualMap: {
					// 左下角的颜色区域
					type: 'piecewise', // 定义为分段型 visualMap
					min: 0,
					max: 100000,
					itemWidth: 40,
					bottom: 60,
					left: -120,
					pieces: [
						// 自定义『分段式视觉映射组件（visualMapPiecewise）』的每一段的范围，以及每一段的文字，以及每一段的特别的样式
						{ gt: 151, lte:200, color: '#ffff00' }, // (101, 150]
						{ gt: 101, lte: 150, color: '#ffeb3b' }, // (101, 150]
						{ gt: 51, lte:100, color: '#ff9800' }, // (51, 100]
						{ gt: 1, lte: 50, color: '#55ff7f' }, // (1， 50]
						{ value: 0, label: '无数据', color: '#0080ff' } // [0]
					]
				},
				// geo配置详解： https://echarts.baidu.com/option.html#geo
				geo: {
					// 地理坐标系组件用于地图的绘制
					map: 'china', // 表示中国地图
					// roam: true, // 是否开启鼠标缩放和平移漫游
					zoom:1.2, // 当前视角的缩放比例（地图的放大比例）
					label: {
						show: true
					},
					itemStyle: {
						// 地图区域的多边形 图形样式。
						borderColor: 'rgba(0, 0, 0, 0.2)',
						emphasis: {
							// 高亮状态下的多边形和标签样式
							shadowBlur: 20,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					}
				},
				series: [
					{
						name: '', // 浮动框的标题（上面的formatter自定义了提示框数据，所以这里可不写）
						type: 'map',
						geoIndex: 0,
						label: {
							show: true
						},
						// 这是需要配置地图上的某个地区的数据，根据后台的返回的数据进行拼接（下面是我定义的假数据）
						data: data
					}
				]
			};
			myChartChina.setOption(optionMap);
			window.onresize = function() {
				// resizeMyChartContainer();
				myChartChina.resize();
			};
		},
		// 根绝类型切换柱状图表
		changeType(val) {
			this.type = val;
			console.log('111', this.type);
			this.chartData();
		},
		// 圆环
		ringChart(data) {
			var myChart = echarts.init(document.getElementById('main'));
			this.optionring = {
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				color: ['#55acff', '#0080ff', '#18aeb7'],
				series: [
					{
						name: '省份',
						type: 'pie',
						radius: ['55%', '70%'],
						avoidLabelOverlap: false,
						emphasis: {
							label: {
								fontSize: '20',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: data
					}
				]
			};
			myChart.setOption(this.optionring);
			window.onresize = function() {
				myChart.resize();
			};
		},
		// 初始化获取地图与圆环数据
		loadData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.aireObj}?questionnaireId=${that.wid}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.mapData = [];
						that.ringData = [];
						that.chaertData = res.resultBody.datas;
						for (let i = 0; i < that.chaertData.length; i++) {
							let name = that.chaertData[i].crew || '其他'
							var areaName = name.replace(/省|市|自治区|特别行政区|壮族|回族|维吾尔/g,"");
							that.mapData.push({ name: areaName, value: that.chaertData[i].num });
							that.ringData.push({ value: that.chaertData[i].num, name: areaName });
						}

						that.initChart(that.mapData);
						that.ringChart(that.ringData);
						that.TopEmpty = false;
					} else {
						that.TopEmpty = true;
					}
				}
			};
			this.$util.request(params);
		},
		// 初始化柱状图数据 , 默认为按设备类型查找
		chartData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.ObjType}?questionnaireId=${that.wid}&type=${that.type}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						let datax = [];
						let datay = [];
						if (that.type == 0) {
							for (let i = 0; i < res.resultBody.datas.length; i++) {
								// if (res.resultBody.datas[i].crew == 0) {
								// 	datax.push('手机');
								// }
								// if (res.resultBody.datas[i].crew == 1) {
								// 	datax.push('电脑');
								// }
								datax.push(res.resultBody.datas[i].crew);
								datay.push(res.resultBody.datas[i].num);
							}
							console.log('111', datax);
						}
						if (that.type == 1 || that.type == 2) {
							for (let i = 0; i < res.resultBody.datas.length; i++) {
								datax.push(res.resultBody.datas[i].crew ||'其他') ;
								datay.push(res.resultBody.datas[i].num);
							}
						}
						that.barChart(datax, datay);
						console.log('访问环境的图标数据', res);
						that.BotEmpty = false;
					} else {
						that.BotEmpty = true;
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped lang="scss">
.sourceAnalysis {
	height: auto;
	.geographical_distribution {
		.geographical_distribution_div {
			min-width: 900px;
			height: 560px;
			background: #fff;
			display: flex;
			justify-content: space-around;
			.map {
				margin-top: 30px;
			}
			.mapStatistics {
				margin-top: 60px;
			}
		}
	}
	.access_environment {
		min-width: 900px;
		height: auto;
		margin: 46px auto;
		.chart_box {
			width: 100%;
			height: auto;
			background: #fff;
			margin-top: 16px;
		}
	}
}
/deep/.el-input__inner {
	border: 1px solid #ccc !important;
}
/deep/.el-input__inner:hover {
	border: 1px solid #0080ff !important;
}
.chart_exhibition {
	margin-top: 70px;
}
.dataScreening {
	height: auto;
	margin-top: 26px;
}
.data_box {
	height: 120px;
	background: #ffffff;
	box-shadow: 0px 2px 5px 0px rgba(176, 176, 176, 0.7);
	margin-top: 16px;
	display: flex;
	align-items: center;
}
.data_show_right {
	width: 563px;
	height: 80px;
	text-align: center;
	font-size: 14px;
	display: flex;
	flex-direction: column;
}
.data_show {
	width: 563px;
	height: 80px;
	border-right: 1px dashed #ccc;
	text-align: center;
	font-size: 14px;
	display: flex;
	flex-direction: column;
}
</style>
